import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://launch-api.sixtix.nl/v1',
});

export default instance;
